<template>
  <div class="item" @click="handleClick">
    <img class="qs-icon" :src="item.avatar" alt="">
    <span class="qs-name text-primary">{{item.qsname}}</span>
    <div class="qs-activity" v-for="label in item.activity_labels.slice(0,2)" :key="label.id">{{label.content}}</div>
    <img class="arrow-icon" src="../images/icon_list_forwardNew@3x.png" alt="">
  </div>
</template>

<script>
export default {
  name: "ActivityItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
};
</script>

<style scoped lang="less">
@import "../style/mixins";
.item {
  box-sizing: border-box;
  height: 1.28rem;
  .theme-mixins(background, rgba(246, 246, 246, 0.60), rgba(37,37,37,0.60));
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0.24rem;

  .qs-icon {
    width: 0.8rem;
    height: 0.8rem;
  }

  .qs-name {
    font-family: PingFangSC-Medium;
    font-size: 0.32rem;
    letter-spacing: 0;
    font-weight: 500;
    margin-left: 0.08rem;
  }

  .qs-activity{
    height: 0.32rem;
    box-sizing: border-box;
    font-size: 0.2rem;
    border-radius: 0.08rem;
    margin-left: 0.08rem;
    font-family: PingFangSC-Regular;
    border: 0.01rem solid #FE6E00;
    .theme-mixins(background, #FEF8E1, rgba(217, 108, 22, 0.10));
    .theme-mixins(color, #FE6E00, #D96C16);
    letter-spacing: 0;
    line-height: 0.2rem;
    font-weight: 400;
    padding: 0.06rem 0.08rem;
  }
  .arrow-icon {
    margin-left: auto;
    width: 0.24rem;
    height: 0.24rem;
  }
}
</style>
